export const quotes = [
  "Langkah kecil hari ini bisa membawamu lebih dekat ke kampus impian.",
  "Bukan tentang seberapa cepat kamu mulai, tetapi seberapa konsisten kamu melangkah.",
  "Dream big. Prepare deliberately.",
  "Kesiapan dibangun dari kebiasaan kecil yang diulang setiap hari.",
  "Dunia lebih dekat dari yang kamu kira — teruslah melangkah.",
  "Peluang datang kepada mereka yang sudah bersiap.",
];

export const roadmapPhases = [
  {
    id: "A", title: "12+ Bulan Sebelum",
    tasks: [
      { task_id: "a1", title: "Tentukan negara dan universitas", reason: "Fondasi semua langkah berikutnya.", priority: "High", estimated_effort: "2-4 minggu", dependency_ids: [], evidence_required: "Shortlist 3-5 kampus" },
      { task_id: "a2", title: "Tingkatkan kemampuan bahasa", reason: "Skor bahasa butuh waktu untuk naik.", priority: "High", estimated_effort: "Berkelanjutan", dependency_ids: [], evidence_required: "Skor diagnostik" },
      { task_id: "a3", title: "Bangun pengalaman & prestasi", reason: "Memperkuat profil non-akademik.", priority: "Medium", estimated_effort: "Berkelanjutan", dependency_ids: [], evidence_required: "Portofolio/aktivitas" },
    ],
  },
  {
    id: "B", title: "6 Bulan Sebelum",
    tasks: [
      { task_id: "b1", title: "Ambil tes IELTS/TOEFL", reason: "Banyak beasiswa mewajibkan skor resmi.", priority: "High", estimated_effort: "1 hari (setelah persiapan)", dependency_ids: ["a2"], evidence_required: "Sertifikat resmi" },
      { task_id: "b2", title: "Siapkan CV akademik", reason: "Dokumen inti hampir semua aplikasi.", priority: "Medium", estimated_effort: "3-5 hari", dependency_ids: ["a3"], evidence_required: "CV final" },
      { task_id: "b3", title: "Siapkan surat rekomendasi", reason: "Perlu waktu dari pemberi rekomendasi.", priority: "High", estimated_effort: "2-3 minggu", dependency_ids: ["a1"], evidence_required: "2 surat" },
      { task_id: "b4", title: "Mulai menulis esai", reason: "Esai kuat butuh banyak revisi.", priority: "High", estimated_effort: "3-4 minggu", dependency_ids: ["a1"], evidence_required: "Draf esai" },
    ],
  },
  {
    id: "C", title: "3 Bulan Sebelum",
    tasks: [
      { task_id: "c1", title: "Finalisasi dokumen", reason: "Pastikan lengkap sebelum submit.", priority: "High", estimated_effort: "1 minggu", dependency_ids: ["b2", "b3", "b4"], evidence_required: "Checklist lengkap" },
      { task_id: "c2", title: "Submit aplikasi", reason: "Jangan tunggu deadline.", priority: "High", estimated_effort: "1-2 hari", dependency_ids: ["c1"], evidence_required: "Bukti submit" },
      { task_id: "c3", title: "Persiapan wawancara", reason: "Tahap seleksi penting.", priority: "Medium", estimated_effort: "2 minggu", dependency_ids: ["c2"], evidence_required: "Simulasi wawancara" },
    ],
  },
  {
    id: "D", title: "1 Bulan Sebelum",
    tasks: [
      { task_id: "d1", title: "Pantau status aplikasi", reason: "Respon cepat jika ada permintaan tambahan.", priority: "Medium", estimated_effort: "Berkelanjutan", dependency_ids: ["c2"], evidence_required: "-" },
      { task_id: "d2", title: "Latihan wawancara intensif", reason: "Meningkatkan kepercayaan diri.", priority: "High", estimated_effort: "2 minggu", dependency_ids: ["c3"], evidence_required: "-" },
    ],
  },
  {
    id: "E", title: "Submission",
    tasks: [
      { task_id: "e1", title: "Konfirmasi semua berkas terkirim", reason: "Hindari diskualifikasi administratif.", priority: "High", estimated_effort: "1 hari", dependency_ids: ["c2"], evidence_required: "Email konfirmasi" },
    ],
  },
  {
    id: "F", title: "Interview / Test",
    tasks: [
      { task_id: "f1", title: "Hadiri wawancara/tes", reason: "Tahap penentu banyak beasiswa.", priority: "High", estimated_effort: "1 hari", dependency_ids: ["d2"], evidence_required: "-" },
    ],
  },
  {
    id: "G", title: "Decision",
    tasks: [
      { task_id: "g1", title: "Tinjau hasil & rencana cadangan", reason: "Selalu siapkan Plan B.", priority: "Medium", estimated_effort: "1 minggu", dependency_ids: ["f1"], evidence_required: "-" },
    ],
  },
  {
    id: "H", title: "Visa",
    tasks: [
      { task_id: "h1", title: "Ajukan visa pelajar", reason: "Proses bisa memakan waktu.", priority: "High", estimated_effort: "2-6 minggu", dependency_ids: ["g1"], evidence_required: "Dokumen visa" },
    ],
  },
  {
    id: "I", title: "Pre-departure",
    tasks: [
      { task_id: "i1", title: "Siapkan akomodasi & keberangkatan", reason: "Transisi yang mulus ke negara tujuan.", priority: "Medium", estimated_effort: "2-4 minggu", dependency_ids: ["h1"], evidence_required: "Booking & tiket" },
    ],
  },
];

export const benefitCategories = [
  { id: "tuition", label: "Tuition Fee", icon: "GraduationCap", desc: "Biaya kuliah" },
  { id: "living", label: "Living Allowance", icon: "Wallet", desc: "Tunjangan hidup" },
  { id: "accommodation", label: "Accommodation", icon: "Home", desc: "Tempat tinggal" },
  { id: "flight", label: "Flight", icon: "Plane", desc: "Tiket pesawat" },
  { id: "insurance", label: "Insurance", icon: "ShieldCheck", desc: "Asuransi kesehatan" },
  { id: "visa", label: "Visa Fee", icon: "Stamp", desc: "Biaya visa" },
  { id: "research", label: "Research Grant", icon: "FlaskConical", desc: "Dana penelitian" },
  { id: "book", label: "Book/Study Allowance", icon: "BookOpen", desc: "Tunjangan buku" },
  { id: "settlement", label: "Relocation/Settlement", icon: "Package", desc: "Dana kedatangan" },
  { id: "family", label: "Family/Dependent", icon: "Users", desc: "Tunjangan keluarga" },
  { id: "language", label: "Language Preparation", icon: "Languages", desc: "Kelas bahasa" },
  { id: "other", label: "Other", icon: "MoreHorizontal", desc: "Lainnya" },
];

// Coverage matrix per scholarship & benefit. Preserve conditions — never turn "may cover" into "covered".
export const benefitCoverage = {
  chevening: {
    tuition: { status: "Fully Covered", note: "Biaya kuliah penuh 1 tahun.", certainty: "High" },
    living: { status: "Fixed Allowance", note: "Stipend bulanan sesuai tarif Chevening.", certainty: "High" },
    flight: { status: "Fully Covered", note: "Tiket PP kelas ekonomi.", certainty: "High" },
    visa: { status: "Fully Covered", note: "Biaya aplikasi visa.", certainty: "High" },
    insurance: { status: "Conditional", note: "Tergantung ketentuan tahun berjalan — verifikasi.", certainty: "Medium" },
  },
  lpdp: {
    tuition: { status: "Fully Covered", note: "SPP penuh sesuai LoA.", certainty: "High" },
    living: { status: "Fixed Allowance", note: "Tunjangan hidup bulanan.", certainty: "High" },
    flight: { status: "Fully Covered", note: "Tiket keberangkatan & kepulangan.", certainty: "High" },
    insurance: { status: "Fully Covered", note: "Asuransi kesehatan.", certainty: "High" },
    book: { status: "Fixed Allowance", note: "Tunjangan buku tahunan.", certainty: "Medium" },
    research: { status: "Conditional", note: "Tergantung program & kebutuhan riset.", certainty: "Medium" },
    settlement: { status: "Fixed Allowance", note: "Tunjangan kedatangan.", certainty: "Medium" },
  },
  erasmus: {
    tuition: { status: "Fully Covered", note: "Participation cost ditanggung.", certainty: "High" },
    living: { status: "Fixed Allowance", note: "Monthly subsistence allowance.", certainty: "High" },
    flight: { status: "Fixed Allowance", note: "Travel allowance sesuai jarak.", certainty: "Medium" },
    insurance: { status: "Fully Covered", note: "Asuransi konsorsium.", certainty: "Medium" },
    settlement: { status: "Fixed Allowance", note: "Installation costs.", certainty: "Medium" },
  },
  "australia-awards": {
    tuition: { status: "Fully Covered", note: "Tuition penuh.", certainty: "High" },
    living: { status: "Fixed Allowance", note: "Contribution to Living Expenses (CLE).", certainty: "High" },
    flight: { status: "Fully Covered", note: "Return air travel.", certainty: "High" },
    insurance: { status: "Fully Covered", note: "OSHC.", certainty: "High" },
    settlement: { status: "Fixed Allowance", note: "Establishment allowance.", certainty: "Medium" },
  },
  mext: {
    tuition: { status: "Fully Covered", note: "Bebas biaya kuliah.", certainty: "High" },
    living: { status: "Fixed Allowance", note: "Tunjangan bulanan MEXT.", certainty: "High" },
    flight: { status: "Conditional", note: "Tiket sesuai ketentuan MEXT — verifikasi.", certainty: "Medium" },
    language: { status: "Fully Covered", note: "Pelatihan bahasa Jepang (jika berlaku).", certainty: "Medium" },
  },
  ggs: {
    tuition: { status: "Unknown", note: "Belum diverifikasi untuk siklus ini.", certainty: "Low" },
    living: { status: "Unknown", note: "Belum diverifikasi.", certainty: "Low" },
    flight: { status: "Unknown", note: "Belum diverifikasi.", certainty: "Low" },
    family: { status: "Conditional", note: "May cover — bergantung ketentuan.", certainty: "Low" },
  },
};

export const faq = [
  { q: "Apakah Scholavia menjamin saya lolos beasiswa?", a: "Tidak. Scholavia adalah alat persiapan. Skor readiness dan match bukan probabilitas penerimaan." },
  { q: "Apakah data saya aman?", a: "Ya. Semua data profil, tes, dan roadmap disimpan lokal di browser kamu (localStorage), tidak dikirim ke server." },
  { q: "Apakah soal tes ini resmi?", a: "Bukan. Semua soal berlabel 'Scholavia Practice Question' dan hanya untuk latihan diagnostik." },
  { q: "Bagaimana readiness dihitung?", a: "Menggunakan Scholavia Readiness Framework v1.0 berdasarkan profil kamu di 5 domain: Akademik, Bahasa, Pengalaman, Finansial, Aplikasi." },
];
